/**
 * @fileoverview gRPC-Web generated client stub for fitness.service.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: fitness-service/v1/agency.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var fitness$service_v1_common_pb = require('../../fitness-service/v1/common_pb.js')
const proto = {};
proto.fitness = {};
proto.fitness.service = {};
proto.fitness.service.v1 = require('./agency_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.AgencyServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.AgencyServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.CreateTrainerAccountRequest,
 *   !proto.fitness.service.v1.TrainerAccountResponse>}
 */
const methodDescriptor_AgencyService_CreateTrainerAccount = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AgencyService/CreateTrainerAccount',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.CreateTrainerAccountRequest,
  proto.fitness.service.v1.TrainerAccountResponse,
  /**
   * @param {!proto.fitness.service.v1.CreateTrainerAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.TrainerAccountResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.CreateTrainerAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.TrainerAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.TrainerAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AgencyServiceClient.prototype.createTrainerAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/CreateTrainerAccount',
      request,
      metadata || {},
      methodDescriptor_AgencyService_CreateTrainerAccount,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.CreateTrainerAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.TrainerAccountResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AgencyServicePromiseClient.prototype.createTrainerAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/CreateTrainerAccount',
      request,
      metadata || {},
      methodDescriptor_AgencyService_CreateTrainerAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetAgencySingleTrainerRequest,
 *   !proto.fitness.service.v1.GetAgencySingleTrainerResponse>}
 */
const methodDescriptor_AgencyService_GetAgencySingleTrainer = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AgencyService/GetAgencySingleTrainer',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetAgencySingleTrainerRequest,
  proto.fitness.service.v1.GetAgencySingleTrainerResponse,
  /**
   * @param {!proto.fitness.service.v1.GetAgencySingleTrainerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetAgencySingleTrainerResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetAgencySingleTrainerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetAgencySingleTrainerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetAgencySingleTrainerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AgencyServiceClient.prototype.getAgencySingleTrainer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/GetAgencySingleTrainer',
      request,
      metadata || {},
      methodDescriptor_AgencyService_GetAgencySingleTrainer,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetAgencySingleTrainerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetAgencySingleTrainerResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AgencyServicePromiseClient.prototype.getAgencySingleTrainer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/GetAgencySingleTrainer',
      request,
      metadata || {},
      methodDescriptor_AgencyService_GetAgencySingleTrainer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetAgencyAllTrainersRequest,
 *   !proto.fitness.service.v1.GetAgencyAllTrainersResponse>}
 */
const methodDescriptor_AgencyService_GetAgencyAllTrainers = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AgencyService/GetAgencyAllTrainers',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetAgencyAllTrainersRequest,
  proto.fitness.service.v1.GetAgencyAllTrainersResponse,
  /**
   * @param {!proto.fitness.service.v1.GetAgencyAllTrainersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetAgencyAllTrainersResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetAgencyAllTrainersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetAgencyAllTrainersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetAgencyAllTrainersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AgencyServiceClient.prototype.getAgencyAllTrainers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/GetAgencyAllTrainers',
      request,
      metadata || {},
      methodDescriptor_AgencyService_GetAgencyAllTrainers,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetAgencyAllTrainersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetAgencyAllTrainersResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AgencyServicePromiseClient.prototype.getAgencyAllTrainers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/GetAgencyAllTrainers',
      request,
      metadata || {},
      methodDescriptor_AgencyService_GetAgencyAllTrainers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetAgencyProfileRequest,
 *   !proto.fitness.service.v1.AgencyProfileResponse>}
 */
const methodDescriptor_AgencyService_GetAgencyProfile = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AgencyService/GetAgencyProfile',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetAgencyProfileRequest,
  proto.fitness.service.v1.AgencyProfileResponse,
  /**
   * @param {!proto.fitness.service.v1.GetAgencyProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.AgencyProfileResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetAgencyProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.AgencyProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.AgencyProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AgencyServiceClient.prototype.getAgencyProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/GetAgencyProfile',
      request,
      metadata || {},
      methodDescriptor_AgencyService_GetAgencyProfile,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetAgencyProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.AgencyProfileResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AgencyServicePromiseClient.prototype.getAgencyProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/GetAgencyProfile',
      request,
      metadata || {},
      methodDescriptor_AgencyService_GetAgencyProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.UpdateAgencyProfileRequest,
 *   !proto.fitness.service.v1.AgencyProfileResponse>}
 */
const methodDescriptor_AgencyService_UpdateAgencyProfile = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AgencyService/UpdateAgencyProfile',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.UpdateAgencyProfileRequest,
  proto.fitness.service.v1.AgencyProfileResponse,
  /**
   * @param {!proto.fitness.service.v1.UpdateAgencyProfileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.AgencyProfileResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.UpdateAgencyProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.AgencyProfileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.AgencyProfileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AgencyServiceClient.prototype.updateAgencyProfile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/UpdateAgencyProfile',
      request,
      metadata || {},
      methodDescriptor_AgencyService_UpdateAgencyProfile,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.UpdateAgencyProfileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.AgencyProfileResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AgencyServicePromiseClient.prototype.updateAgencyProfile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/UpdateAgencyProfile',
      request,
      metadata || {},
      methodDescriptor_AgencyService_UpdateAgencyProfile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.DeactivateTrainerAccountRequest,
 *   !proto.fitness.service.v1.TrainerAccountResponse>}
 */
const methodDescriptor_AgencyService_DeactivateTrainerAccount = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AgencyService/DeactivateTrainerAccount',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.DeactivateTrainerAccountRequest,
  proto.fitness.service.v1.TrainerAccountResponse,
  /**
   * @param {!proto.fitness.service.v1.DeactivateTrainerAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.TrainerAccountResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.DeactivateTrainerAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.TrainerAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.TrainerAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AgencyServiceClient.prototype.deactivateTrainerAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/DeactivateTrainerAccount',
      request,
      metadata || {},
      methodDescriptor_AgencyService_DeactivateTrainerAccount,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.DeactivateTrainerAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.TrainerAccountResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AgencyServicePromiseClient.prototype.deactivateTrainerAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/DeactivateTrainerAccount',
      request,
      metadata || {},
      methodDescriptor_AgencyService_DeactivateTrainerAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.ActivateTrainerAccountRequest,
 *   !proto.fitness.service.v1.TrainerAccountResponse>}
 */
const methodDescriptor_AgencyService_ActivateTrainerAccount = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AgencyService/ActivateTrainerAccount',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.ActivateTrainerAccountRequest,
  proto.fitness.service.v1.TrainerAccountResponse,
  /**
   * @param {!proto.fitness.service.v1.ActivateTrainerAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.TrainerAccountResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.ActivateTrainerAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.TrainerAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.TrainerAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AgencyServiceClient.prototype.activateTrainerAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/ActivateTrainerAccount',
      request,
      metadata || {},
      methodDescriptor_AgencyService_ActivateTrainerAccount,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.ActivateTrainerAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.TrainerAccountResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AgencyServicePromiseClient.prototype.activateTrainerAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/ActivateTrainerAccount',
      request,
      metadata || {},
      methodDescriptor_AgencyService_ActivateTrainerAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest,
 *   !proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse>}
 */
const methodDescriptor_AgencyService_GetAgencyTrainerClientRelations = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.AgencyService/GetAgencyTrainerClientRelations',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest,
  proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse,
  /**
   * @param {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.AgencyServiceClient.prototype.getAgencyTrainerClientRelations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/GetAgencyTrainerClientRelations',
      request,
      metadata || {},
      methodDescriptor_AgencyService_GetAgencyTrainerClientRelations,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetAgencyTrainerClientRelationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetAgencyTrainerClientRelationsResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.AgencyServicePromiseClient.prototype.getAgencyTrainerClientRelations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.AgencyService/GetAgencyTrainerClientRelations',
      request,
      metadata || {},
      methodDescriptor_AgencyService_GetAgencyTrainerClientRelations);
};


module.exports = proto.fitness.service.v1;

